import axios from "axios";
import Vue from "vue";

const getDefaultState = () => {
  return {
    step: 1,
    enviarCodigoVia: "Whatsapp",
    telefoneSelecionado: "",
    codigoEnviado: false,
    codigoRecebido: "",
    enviandoCodigo: false,
    validandoCodigo: false,
    parametros: null,
    cfg_senha: {
      senha: "",
      conf_senha: "",
    },
    salvandoSenha: false,
    autorizados: [],
    carregandoAutorizados: false,
    removendoAutorizado: false,
    cpfPesquisar: "",
    consultandoCpf: false,
    cpf_consultado: {
      nome: "",
      data_nasc: "",
      valido: false,
      msg: "",
    },
    criandoAutorizado: false,
    dialogAviso: false,
  };
};

const configComprasPrazoStore = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setStep(state, value) {
      state.step = value;
    },
    setEnviarCodigoVia(state, value) {
      state.enviarCodigoVia = value;
    },
    setTelefone(state, value) {
      state.telefoneSelecionado = value;
    },
    setCodEnviado(state, value) {
      state.codigoEnviado = value;
    },
    setCodigoRecebido(state, value) {
      state.codigoRecebido = value;
    },
    setEnviandoCodigo(state, value) {
      state.enviandoCodigo = value;
    },
    setValidandoCodigo(state, value) {
      state.validandoCodigo = value;
    },
    setParametros(state, value) {
      state.parametros = value;
    },
    setSalvandoSenha(state, value) {
      state.salvandoSenha = value;
    },
    setAutorizados(state, value) {
      state.autorizados = value;
    },
    setCarregAutorizados(state, value) {
      state.carregandoAutorizados = value;
    },
    setRemovendoAutorizado(state, value) {
      state.removendoAutorizado = value;
    },
    setConsultandoCpf(state, value) {
      state.consultandoCpf = value;
    },
    setCpfConsultado(state, value) {
      if ("nome" in value) state.cpf_consultado.nome = value.nome;
      if ("data_nasc" in value)
        state.cpf_consultado.data_nasc = value.data_nasc;
      if ("valido" in value) state.cpf_consultado.valido = value.valido;
      if ("msg" in value) state.cpf_consultado.msg = value.msg;
    },
    setCpfPesquisar(state, value) {
      state.cpfPesquisar = value;
    },
    setCriandoAutorizado(state, value) {
      state.criandoAutorizado = value;
    },
    setDialogAviso(state, value) {
      state.dialogAviso = value;
    },
  },
  actions: {
    async buscarParametros(context) {
      context.commit("setParametros", null);
      try {
        var res = await axios.get("/colaborador/compras-prazo/parametros");
        if (res.data.success) {
          context.commit("setParametros", res.data.data);
        }
      } catch (error) {
        Vue.toasted.error(error, { position: "bottom-center" });
      }
    },
    async enviarCodigoSeguranca(context) {
      context.commit("setEnviandoCodigo", true);
      try {
        var res = await axios.post(
          "/colaborador/compras-prazo/enviar-codigo-seguranca",
          {},
          {
            params: {
              opcao: context.state.enviarCodigoVia,
              telefone: context.state.telefoneSelecionado,
            },
          }
        );
        if (res.data.success) {
          context.commit("setStep", 2);
          context.commit("setCodEnviado", true);
          Vue.toasted.success(res.data.msg, { position: "bottom-center" });
        } else {
          Vue.toasted.error(res.data.msg, { position: "bottom-center" });
        }
      } catch (error) {
        Vue.toasted.error(error, { position: "bottom-center" });
      } finally {
        context.commit("setEnviandoCodigo", false);
      }
    },
    async validarCodigoSeguranca(context) {
      context.commit("setValidandoCodigo", true);
      try {
        var res = await axios.post(
          "/colaborador/compras-prazo/validar-codigo-seguranca",
          {},
          {
            params: {
              codigo: context.state.codigoRecebido,
            },
          }
        );
        if (res.data.success) {
          context.dispatch("buscarParametros");
        } else {
          Vue.toasted.error(res.data.msg, { position: "bottom-center" });
        }
      } catch (error) {
        Vue.toasted.error(error, { position: "bottom-center" });
      } finally {
        context.commit("setValidandoCodigo", false);
      }
    },
    async configurarSenha(context) {
      context.commit("setSalvandoSenha", true);
      try {
        var res = await axios.post(
          "/colaborador/compras-prazo/configurar-senha",
          context.state.cfg_senha
        );
        if (!res.data.success) {
          Vue.toasted.error(res.data.msg);
          return false;
        } else {
          Vue.toasted.success(res.data.msg);
          return true;
        }
      } catch (error) {
        Vue.toasted.error(error, { position: "bottom-center" });
        return false;
      } finally {
        context.commit("setSalvandoSenha", false);
      }
    },
    async carregarAutorizados(context) {
      context.commit("setCarregAutorizados", true);
      context.commit("setAutorizados", []);
      try {
        var res = await axios.get(
          "/colaborador/compras-prazo/carregar-autorizados"
        );
        if (res.status == 200) {
          context.commit("setAutorizados", res.data);
        }
      } catch (error) {
        Vue.toasted.error(error);
      } finally {
        context.commit("setCarregAutorizados", false);
      }
    },
    async removerAutorizado(context, id) {
      context.commit("setRemovendoAutorizado", true);
      try {
        var res = await axios.delete(
          "/colaborador/compras-prazo/remover-autorizado",
          {
            params: {
              id: id,
            },
          }
        );
        if (res.data.success) {
          Vue.toasted.success(res.data.msg, { position: "bottom-center" });
          return true;
        } else {
          Vue.toasted.error(res.data.msg, { position: "bottom-center" });
          return false;
        }
      } catch (error) {
        Vue.toasted.error(error, { position: "bottom-center" });
        return false;
      } finally {
        context.commit("setRemovendoAutorizado", false);
      }
    },
    async consultarCpf(context) {
      context.commit("setConsultandoCpf", true);
      context.commit("setCpfConsultado", {
        nome: "",
        data_nasc: "",
        valido: false,
        msg: "",
      });
      try {
        var res = await axios.get("/colaborador/compras-prazo/consultar-cpf", {
          params: {
            cpf: context.state.cpfPesquisar,
          },
        });
        if (res.data.success) {
          var cpfRet = res.data.data;
          cpfRet.valido = true;
          context.commit("setCpfConsultado", cpfRet);
        } else {
          context.commit("setCpfConsultado", { msg: res.data.msg });
          Vue.toasted.error(res.data.msg, { position: "bottom-center" });
        }
      } catch (error) {
        context.commit("setCpfConsultado", { msg: res.data.msg });
        Vue.toasted.error(res.data.msg, { position: "bottom-center" });
      } finally {
        context.commit("setConsultandoCpf", false);
      }
    },
    async criarAutorizado(context) {
      context.commit("setCriandoAutorizado", true);
      try {
        var res = await axios.post(
          "/colaborador/compras-prazo/criar-autorizado",
          { cpf: context.state.cpfPesquisar }
        );
        if (res.data.success) {
          Vue.toasted.success(res.data.msg, { position: "bottom-center" });
          return true;
        } else {
          Vue.toasted.error(res.data.msg, { position: "bottom-center" });
          return false;
        }
      } catch (error) {
        Vue.toasted.error(error, { position: "bottom-center" });
        return false;
      } finally {
        context.commit("setCriandoAutorizado", false);
      }
    },    
  },
  getters: {},
};

export default configComprasPrazoStore;
